import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";

export default function Layout({ children }) {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="min-h-screen bg-linen text-ink flex flex-col">
      <Header />
      <main className="flex-1 pt-24" data-testid="main-content">
        {children}
      </main>
      <Footer />
      <Toaster richColors position="top-right" />
    </div>
  );
}
